import React, { Component } from 'react';
import '../../styles/commoncomponents/temperatureAlertFilter.scss';

class TemperatureAlertFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filterType: 'All',
            enabledChecked: true,
            disabledChecked: true
        };
    }

    handleFilterChange = (e) => {
        const filterType = e.target.value;
        this.setState({ filterType }, () => {
            this.props.onFilterChange({
                filterType,
                enabledChecked: this.state.enabledChecked,
                disabledChecked: this.state.disabledChecked
            });
        });
    }

    handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        this.setState({ [name]: checked }, () => {
            this.props.onFilterChange({
                filterType: this.state.filterType,
                enabledChecked: this.state.enabledChecked,
                disabledChecked: this.state.disabledChecked
            });
        });
    }

    render() {
        return (
            <div className="temperatureAlertFilter">
                <label>Temperature Alert:</label>
                <select onChange={this.handleFilterChange} value={this.state.filterType}>
                    <option value="All">All</option>
                    <option value="Configured">Configured</option>
                    <option value="NotConfigured">Not Configured</option>
                </select>
                
                {this.state.filterType === 'Configured' && (
                    <div className="checkboxContainer">
                        <label>
                            <input 
                                type="checkbox" 
                                name="enabledChecked" 
                                checked={this.state.enabledChecked} 
                                onChange={this.handleCheckboxChange} 
                            />
                            Enabled
                        </label>
                        <label>
                            <input 
                                type="checkbox" 
                                name="disabledChecked" 
                                checked={this.state.disabledChecked} 
                                onChange={this.handleCheckboxChange} 
                            />
                            Disabled
                        </label>
                    </div>
                )}
            </div>
        );
    }
}

export default TemperatureAlertFilter;